export type UiShellVersion = 'legacy' | 'v2';

export type RuntimeConfig = {
  uiShellV2: boolean;
};

export const RUNTIME_CONFIG_PATH = '/runtime-config.json';
export const RUNTIME_CONFIG_TIMEOUT_MS = 2_500;
export const UI_SHELL_STORAGE_KEY = 'ihd-ui-shell-version';

export async function loadRuntimeConfig(fetcher: typeof fetch = fetch): Promise<RuntimeConfig> {
  let timeout: ReturnType<typeof setTimeout> | undefined;
  const controller = typeof AbortController === 'undefined' ? null : new AbortController();
  try {
    return await Promise.race([
      (async () => {
        const response = await fetcher(RUNTIME_CONFIG_PATH, {
          cache: 'no-store',
          ...(controller ? { signal: controller.signal } : {}),
        });
        if (!response.ok) return { uiShellV2: false };
        const value = await response.json() as { uiShellV2?: unknown };
        return { uiShellV2: typeof value?.uiShellV2 === 'boolean' ? value.uiShellV2 : false };
      })(),
      new Promise<never>((_resolve, reject) => {
        timeout = setTimeout(() => {
          controller?.abort();
          reject(new Error('runtime config timeout'));
        }, RUNTIME_CONFIG_TIMEOUT_MS);
      }),
    ]);
  } catch {
    return { uiShellV2: false };
  } finally {
    if (timeout) clearTimeout(timeout);
  }
}

export function resolveUiShellVersion(input: {
  runtimeEnabled: boolean;
  search: string;
  stored: string | null;
}): { version: UiShellVersion; persist?: UiShellVersion } {
  const requested = new URLSearchParams(input.search).get('ui-shell');
  if (requested === 'legacy' || requested === 'v2') {
    return { version: requested, persist: requested };
  }
  if (input.runtimeEnabled) return { version: 'v2' };
  if (input.stored === 'legacy' || input.stored === 'v2') return { version: input.stored };
  return { version: 'legacy' };
}
